import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { puedeFirmar, estado, textoEvento } from 'src/app/utils/firma-workflow';

/**
 * FIRMA DE TANDA (solicitud del workflow de Juan; Mario, 25/26-oct R29; WFT-10). Se abre desde «Altas de comercios»:
 * la ficha de la tanda (la de «Por aprobar»: comercios, Bs, alertas, pagarés) con Firmar y Devolver, y la historia del motor.
 * Firmar y devolver son los de liquidación de siempre (bandas, SEG-02); el núcleo después mueve la solicitud.
 */
@Component({
  selector: 'app-liquidacion-firma',
  templateUrl: './liquidacion-firma.component.html'
})
export class LiquidacionFirmaComponent implements OnInit {
  readonly textoEvento = textoEvento;
  readonly ROL: any = { TES: 'Tesorero', GER: 'Gerente de finanzas', DIR: 'Director' };

  id = '';
  f: any = null;
  cargando = true;
  error = '';
  aviso = '';
  ocupado = false;
  devolviendo = false;
  motivo = '';
  abierto = new Set<string>();

  constructor(private liq: LiquidacionService, private ruta: ActivatedRoute, public _auth: AuthService) { }

  ngOnInit(): void {
    this.id = this.ruta.snapshot.paramMap.get('id') || '';
    this.cargar();
  }

  cargar = async (): Promise<void> => {
    this.cargando = true; this.error = '';
    try { this.f = await this.liq.fichaFirma(this.id); }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo abrir la firma de la tanda.'; }
    finally { this.cargando = false; }
  };

  get puedeFirmar(): boolean { return puedeFirmar(this.f, !!this._auth.hasPermission && this._auth.hasPermission('liquidacion.aprobar')); }
  get estado() { return estado(this.f?.solicitud, this.f?.solicitud?.etapas_total || 1); }
  /** Bs con la tasa BCV del día (BSP-01): sin tasa, null y la cifra principal sigue en USD. */
  bs = (usd: number): number | null => (this.f?.tasa ? Math.round(usd * this.f.tasa * 100) / 100 : null);
  rolDe = (k: string): string => this.ROL[k] || k;
  nombre = (p: any): string => p?.nombre || 'otra persona';
  firmantes = (banda: any): string => (banda?.firmas || []).map((r: string) => this.rolDe(r)).join(' y luego ');

  verPagares = (code: string): void => { this.abierto.has(code) ? this.abierto.delete(code) : this.abierto.add(code); };

  firmar = async (): Promise<void> => {
    this.ocupado = true; this.error = ''; this.aviso = '';
    try {
      const t = await this.liq.firmarTanda(this.f.dia, this.f.tanda.n);
      this.aviso = t?.state === 'APROBADA' ? 'Firmaste: la tanda quedó aprobada.' : 'Firmaste: ahora espera la otra firma.';
      await this.cargar();
    } catch (e: any) { this.error = e?.error?.msg || 'No se pudo firmar.'; }
    finally { this.ocupado = false; }
  };

  devolver = async (): Promise<void> => {
    if (!this.motivo.trim()) { this.error = 'Para devolverla escribe la observación.'; return; }
    this.ocupado = true; this.error = ''; this.aviso = '';
    try {
      await this.liq.devolverTanda(this.f.dia, this.f.tanda.n, this.motivo.trim());
      this.devolviendo = false; this.motivo = ''; this.aviso = 'La devolviste: sus comercios vuelven al tesorero.';
      await this.cargar();
    } catch (e: any) { this.error = e?.error?.msg || 'No se pudo devolver.'; }
    finally { this.ocupado = false; }
  };
}
